<template>
  <div class="em-trans-panel">
    <!-- <div style="width:100%;"><user-choose></user-choose></div> -->
    <div style="display:flex; align-items: center;justify-content:space-between;margin-bottom:10px;">
      <div class="btn-lab">
        <sw-button
          :custom-button-size="9"
          type="primary"
          icon="su-icon-plus"
          @click.stop="show_add_user_panel()"
        >新增用户</sw-button>
        <!-- <sw-button :custom-button-size="9" :disabled="select_arr.length===0" icon="su-icon-delete" simple @click.stop="show_add_user=false">删 除</sw-button> -->
      </div>
      <div class="sea-lab">
        <el-input
          v-model.trim="keyword_has"
          clearable
          placeholder="请输入用户名"
          @change="search_handle()"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="search_handle()"
          />
        </el-input>
        <sw-button
          :custom-button-size="8"
          type="primary"
          icon="su-icon-renew"
          @click="clear_search()"
        />
      </div>
    </div>
    <div style="position:relative;margin-bottom:20x;overflow-y:auto;height:calc(100vh - 250px)">
      <sw-table
        v-loading="!show_has_tab"
        :table-name="'user-tab'"
        :table-data="user_data"
        :table-title="tableTitle"
        :has-operation="true"
        :page-sizes="table_size"
        :total-count="total_count"
        :page-size="10"
        :table-operation="tableOperation"
        :has-add-button="false"
        :show-selection="false"
        @selection-change="select_change"
        @operation-handle="operationHandle"
        @change-page="change_page"
        @size-change="size_change"
      />
    </div>
    <sw-slide-dialog
      :visible.sync="show_add_user"
      :width="'648px'"
      title="新增用户"
    >
      <div
        v-loading="!show_sw1"
        id="sw1"
        class="trans"
      >
        <sw-transfer
          v-loading="loading_user"
          :data-config="{label:'title',value:'value',describe:'describe', disabled:'disabled',}"
          :list="user_list"
          :selected="data.selected"
          :pagination="false"
          :search="false"
          :search-condition="[{name:'userName',value: keyword_user_name}]"
          :lazy="!sw1_no_more"
          height="calc(100vh - 144px)"
          option-label="可选用户"
          @loadmore="get_user_list"
          @change="handleTransferChange"
        >
          <template slot="expansionSearch">
            <div>
              <el-input
                v-model.trim="keyword_user_name"
                placeholder="请输入用户名/ID"
              />
            </div>
          </template>
        </sw-transfer>
      </div>
      <span slot="footer">
        <sw-button
          :loading="btn_loading"
          :custom-button-size="9"
          @click="show_add_user=!show_add_user"
        >取 消</sw-button>
        <sw-button
          :custom-button-size="9"
          type="primary"
          @click="add_athu()"
        >确 定</sw-button>
      </span>
    </sw-slide-dialog>
  </div>
</template>
<script>
import { parseTime } from '@/utils/index'
import service from '@/utils/service'
export default {
  data () {
    return {
      data: {},
      user_list: [],
      user_choose: [], // 选择人员数组
      show_sw1: false,
      search_user_tag: false, // 用户搜索标志位
      page: 1,
      selectlist: [],
      keyword_user_name: '',
      sw1_no_more: false,
      timeout: '',
      user_data: [], // 已授权用户列表
      tableTitle: '', // 表头
      total_count: '', // 列表总条数
      tableOperation: '', // 操作
      select_arr: [], // 已选列表
      show_add_user: false,
      pageSize: 10,
      show_has_tab: false,
      keyword_has: '',
      send_service_id: 1,
      btn_loading: false,
      loading_user: false
    }
  },
  computed: {
    table_size () {
      return this.$store.state.app.tableSize
    }
  },
  watch: {
    'keyword_user_name': function (newVal) {
      this.search_user_tag = true
      this.search_user_lan()()
    },
    'show_add_user': function (newVal) {
      this.selectList = []
      this.user_list = []
      this.page = 1
      this.sw1_no_more = false
    }
  },
  created () {
    this.tab_init()
  },
  methods: {
    // 表单数据初始化
    tab_init () {
      // tab2表头
      this.tableTitle = [
        // { prop: 'user_id', label: '用户ID',width:'120', sortable: true },
        { prop: 'account', label: '账户名', width: '120', sortable: true },
        { prop: 'user_name', label: '用户名称', width: '120', sortable: true },
        { prop: 'organizationName', label: '所属机构', width: '120', sortable: true },
        { prop: 'creator', label: '授权人', width: '120', sortable: true },
        { prop: 'create_time', label: '操作时间', width: '154', sortable: true }
      ]
      // tab2操作
      this.tableOperation = [
        { name: '删除', icon: 'su-icon-delete', operation: 'delete' }
      ]
      this.limit = this.table_size[0]
      this.get_has_user(1)
    },
    get_has_user (page) {
      var param = {
        user: this.keyword_has,
        appId: this.$route.params.fid,
        page: page,
        limit: this.pageSize
      }
      this.show_has_tab = false
      service.get('/v1/appAccess/queryAuthUserList', { params: param }).then((res) => {
        if (res.data) {
          this.user_data = res.data.map(item => {
            item.create_time = parseTime(item.create_time)
            return item
          })
        } else {
          this.user_data = []
        }
        this.total_count = res.count
        this.show_has_tab = true
      }).catch(res => {
        this.$swMessage({
          message: res,
          type: 'error'
        })
      })
    },
    // 选择
    select_change (sel) {
      this.select_arr = sel
    },
    // 切换页面
    change_page (page) {
      this.get_has_user(page)
    },
    // 切换表格数据显示大小
    size_change (size) {
      this.pageSize = size
      this.get_has_user(1)
    },
    // 列表操作设置
    operationHandle (id, operation) {
      if (this[`${operation}Handle`]) {
        this[`${operation}Handle`](id)
      }
    },
    // 删除操作
    deleteHandle (id) {
      var selUser = {}
      this.user_data.some(u => {
        if (u.id === id) {
          selUser = u
          return true
        }
      })
      var param = {
        id: selUser.id,
        type: 'user'
      }
      service.get('/v1/appAccess/deleteAccessAuth', { params: param }).then((res) => {
        this.show_has_tab = false
        this.get_has_user(1)
        this.$swMessage({
          message: `删除${selUser.user_name}授权成功`,
          type: 'success'
        })
      }).catch(res => {
        this.$swMessage({
          message: res,
          type: 'error'
        })
      })
    },
    // 显示增加用户侧边栏
    show_add_user_panel () {
      this.keyword_user_name = ''
      this.$set(this.data, 'selected', [])
      this.show_add_user = true
      const loadHasUser = async () => {
        return new Promise((resolve, reject) => {
          const param = {
            appId: this.$route.params.fid,
            page: 1,
            limit: 100
          }
          service.get('/v1/appAccess/queryAuthUserList', { params: param }).then((res) => {
            if (res.data) {
              this.selectlist = res.data.map(item => {
                return { title: item.user_name, value: item.user_id, describe: item.user_id, userName: `${item.user_name}|${item.user_id}|${item.organizationName}` }
              })
            }
            resolve()
          })
        })
      }
      const nextStep = async () => {
        await loadHasUser()
        this.get_user_list()
      }
      nextStep()
    },
    // 获取用户列表
    get_user_list () {
      if (this.sw1_no_more) {
        return
      }
      // 请求编号设置
      this.send_service_id++
      const thatId = this.send_service_id
      var param = {
        keyword: this.keyword_user_name,
        pageNum: this.page,
        pageSize: 50
      }
      // /v1/user/selectUserList
      this.loading_user = this.page === 1
      service.get('/v1/data/share/user/pageTotalUnused', { params: param }).then(res => {
        this.loading_user = false
        if (thatId !== this.send_service_id) {
          return
        }
        var tempArr = res.data.map(item => {
          return { title: item.name, value: item.id, describe: item.accountName, userName: `${item.name}|${item.id}|${item.accountName}|${item.organizationName}` }
        })
        if (res.data && res.data.length < 50) {
          this.sw1_no_more = true
        }
        // 输入搜索内容时做的操作
        if (this.search_user_tag) {
          this.user_list = []
          this.search_user_tag = false
        }
        if (this.page > 1) {
          tempArr = tempArr.filter(f => {
            const _same = this.data.selected.some(s => {
              return f.value === s
            })
            return !_same
          })
          this.user_list = this.user_list.concat(tempArr)
          this.page++
          return
        }
        var userArr = this.user_list.concat(tempArr)
        var userSelNone = []
        // 搜索用户后将右侧已选人员添加至左侧列表
        this.selectlist.forEach(s => {
          var same = userArr.some(u => {
            if (u.value === s.value) { u.disabled = true }
            return u.value === s.value
          })
          if (!same) {
            s.disabled = true
            userSelNone.push(s)
          }
        })
        // userSelNone.concat(userArr)
        this.user_list = userArr.concat(userSelNone)
        this.data.selected = this.selectlist.map(i => {
          return i.value
        })
        if (this.page === 1) {
          this.show_sw1 = true
        }
        this.page++
      })
    },
    // 添加授权
    add_athu () {
      if (this.selectlist.length === 0) {
        return
      }
      this.selectlist.forEach(s => {
        s.user_name = s.title
      })
      var json = { users: this.selectlist, groups: [], ogs: [] }
      json.appId = this.$route.params.fid
      var param = { json: JSON.stringify(json) }
      this.btn_loading = true
      service.post('/v1/appAccess/accessAuth', param).then(res => {
        this.btn_loading = false
        this.clear_search()
        this.show_add_user = false
        this.$swMessage({
          message: `添加授权成功`,
          type: 'success'
        })
      }).catch(err => {
        this.$swMessage({
          message: err,
          type: 'error'
        })
      })
    },
    // 搜索用户（穿梭框）
    search_user () {
      this.sw1_no_more = false
      this.keyword_user_name = this.keyword_user_name
      this.page = 1
      // this.user_list = []
      // this.sw1_no_more = false
      this.get_user_list()
    },
    // 搜索用户（已授权列表）
    search_handle () {
      this.keyword_has = this.keyword_has
      this.show_has_tab = false
      this.get_has_user(1)
    },
    // 清空搜索项
    clear_search () {
      this.show_has_tab = false
      this.get_has_user(1)
    },

    // 懒加载处理
    handleTransferChange (val) {
      this.selectlist = val
      // this.authDiaLogForm.transferList = val
    },
    // 防抖函数
    search_user_lan () {
      return () => {
        clearTimeout(this.timeout)
        const _this = this
        this.timeout = setTimeout(function () { // 在周期内db函数被触发会更新定时器，延迟事件函数的执行
          _this.search_user()
        }, 500)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sea-lab {
  width: 300px;
  display: flex;
  justify-content: cneter;
  align-items: center;
  .el-row {
    flex: 1;
  }
  .sw-button {
    margin-left: 8px !important;
  }
}
</style>
